/**
 * Asynchronously loads the component for GSTR-9 Save
 */

import React from "react";
import loadable from "utils/loadable";
import ClipLoader from "react-spinners/ClipLoader";

export default loadable(() => import("./index"), {
  fallback: (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
      }}
    >
      <ClipLoader size={100} color={"#4f2d7f"} loading={true} />
    </div>
  ),
});
